import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import config from '../../config/apiConfig';

export default function MantenedorStaff() {
    const [staffList, setStaffList] = useState([]);
    const [loading, setLoading] = useState(false);
    
    // Estado del Formulario
    const [modoEdicion, setModoEdicion] = useState(false);
    const [staffActual, setStaffActual] = useState({
        uuid: '',
        nombre: '',
        pin: '',
        rol: 'OPERADOR',
        activo: 1
    });

    const token = localStorage.getItem('token'); 
    const authHeaders = {
        headers: { 
            'token': token, 
            'Content-Type': 'application/json' 
        }
    };

    useEffect(() => {
        cargarStaff();
    }, []);

    const cargarStaff = async () => {
        setLoading(true);
        try {
            const res = await axios.get(`${config.api_url}/api/staff`, authHeaders);
            if (res.data.status === 'success') {
                setStaffList(res.data.data);
            }
        } catch (error) {
            console.error(error);
            toast.error("Error al cargar personal");
        } finally {
            setLoading(false);
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setStaffActual({ ...staffActual, [name]: value });
    };

    const guardarStaff = async (e) => {
        e.preventDefault();
        if (!staffActual.nombre || !staffActual.pin) {
            toast.warning("Nombre y PIN son obligatorios");
            return;
        }

        try {
            if (modoEdicion) {
                await axios.put(`${config.api_url}/api/staff/${staffActual.uuid}`, staffActual, authHeaders);
                toast.success("Personal actualizado");
            } else {
                await axios.post(`${config.api_url}/api/staff`, staffActual, authHeaders);
                toast.success("Personal creado correctamente");
            }
            limpiarFormulario();
            cargarStaff();
        } catch (error) {
            toast.error("Error al guardar");
        }
    };

    const eliminarStaff = async (uuid) => {
        if (!window.confirm("¿Estás seguro de eliminar a este operador?")) return;
        try {
            await axios.delete(`${config.api_url}/api/staff/${uuid}`, authHeaders);
            toast.success("Eliminado correctamente");
            cargarStaff();
        } catch (error) {
            toast.error("Error al eliminar");
        }
    };

    const editar = (staff) => {
        setStaffActual(staff);
        setModoEdicion(true);
    };

    const limpiarFormulario = () => {
        setStaffActual({ uuid: '', nombre: '', pin: '', rol: 'OPERADOR', activo: 1 });
        setModoEdicion(false);
    };

    return (
        /* --- CONTENEDOR PRINCIPAL DEL MÓDULO --- */
        <div className="p-4" style={{ backgroundColor: '#f8f9fa', minHeight: '100vh' }}>
            
            {/* ENCABEZADO DE MÓDULO */}
            <div className="d-flex justify-content-between align-items-center mb-4 bg-white p-3 shadow-sm rounded">
                <div>
                    <h4 className="mb-0 text-primary">
                        <i className="bi bi-person-badge-fill me-2"></i> 
                        Mantenedor de Personal (Staff)
                    </h4>
                    <small className="text-muted">Gestione los operadores y PINs de acceso para el TPV Local</small>
                </div>
                <button className="btn btn-outline-primary btn-sm" onClick={cargarStaff}>
                    <i className="bi bi-arrow-clockwise me-1"></i> Actualizar
                </button>
            </div>

            {/* ÁREA DE TRABAJO (GRID) */}
            <div className="row">
                
                {/* COLUMNA FORMULARIO */}
                <div className="col-md-4">
                    <div className="card border-0 shadow-sm mb-4">
                        <div className={`card-header text-white ${modoEdicion ? 'bg-warning' : 'bg-dark'}`}>
                            <i className={`bi ${modoEdicion ? 'bi-pencil-square' : 'bi-plus-circle'} me-2`}></i>
                            {modoEdicion ? 'Editando Operador' : 'Registrar Nuevo Operador'}
                        </div>
                        <div className="card-body p-4">
                            <form onSubmit={guardarStaff}>
                                <div className="mb-3">
                                    <label className="form-label fw-bold">Nombre Completo</label>
                                    <input 
                                        type="text" className="form-control form-control-lg" name="nombre"
                                        value={staffActual.nombre} onChange={handleChange} 
                                        placeholder="Ej: Juan Pérez" required
                                    />
                                </div>
                                <div className="mb-3">
                                    <label className="form-label fw-bold">PIN de Acceso (4 dígitos)</label>
                                    <input 
                                        type="password" 
                                        maxLength="4"
                                        className="form-control form-control-lg" name="pin"
                                        value={staffActual.pin} onChange={handleChange} 
                                        placeholder="****" required
                                    />
                                    <small className="text-muted">Este PIN se usará para loguearse en el TPV</small>
                                </div>
                                <div className="mb-4">
                                    <label className="form-label fw-bold">Rol en el Sistema</label>
                                    <select className="form-select form-select-lg" name="rol" value={staffActual.rol} onChange={handleChange}>
                                        <option value="OPERADOR">OPERADOR (Ventas/Caja)</option>
                                        <option value="ADMIN">ADMIN (Encargado Local)</option>
                                        <option value="COCINA">COCINA (Solo KDS)</option>
                                        <option value="GARZON">GARZON</option>                                        
                                    </select>
                                </div>
                                
                                <div className="d-grid gap-2">
                                    <button type="submit" className={`btn btn-lg ${modoEdicion ? 'btn-warning' : 'btn-primary'}`}>
                                        {modoEdicion ? 'Guardar Cambios' : 'Crear Operador'}
                                    </button>
                                    {modoEdicion && (
                                        <button type="button" className="btn btn-light" onClick={limpiarFormulario}>
                                            Cancelar
                                        </button>
                                    )}
                                </div>
                            </form>
                        </div>
                    </div>
                </div>

                {/* COLUMNA TABLA DE LISTADO */}
                <div className="col-md-8">
                    <div className="card border-0 shadow-sm">
                        <div className="card-body p-0">
                            <div className="table-responsive">
                                <table className="table table-hover mb-0">
                                    <thead className="bg-light">
                                        <tr>
                                            <th className="px-4 py-3">Operador</th>
                                            <th className="py-3">Rol</th>
                                            <th className="py-3">PIN (Últimos 2)</th>
                                            <th className="py-3 text-end px-4">Acciones</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {loading ? (
                                            <tr><td colSpan="4" className="text-center py-5">Cargando personal...</td></tr>
                                        ) : staffList.length === 0 ? (
                                            <tr><td colSpan="4" className="text-center py-5 text-muted">No hay personal registrado para este negocio</td></tr>
                                        ) : (
                                            staffList.map((st) => (
                                                <tr key={st.uuid}>
                                                    <td className="px-4 py-3">
                                                        <div className="d-flex align-items-center">
                                                            <div className="rounded-circle bg-soft-primary p-2 me-3 text-primary" style={{backgroundColor: '#e7f1ff'}}>
                                                                <i className="bi bi-person-fill"></i>
                                                            </div>
                                                            <span className="fw-bold">{st.nombre}</span>
                                                        </div>
                                                    </td>
                                                    <td className="py-3">
                                                        <span className={`badge ${st.rol === 'ADMIN' ? 'bg-danger' : st.rol === 'COCINA' ? 'bg-warning text-dark' : 'bg-info text-dark'}`}>
                                                            {st.rol}
                                                        </span>
                                                    </td>
                                                    <td className="py-3">
                                                        <code className="text-muted">**{st.pin.toString().slice(-2)}</code>
                                                    </td>
                                                    <td className="text-end px-4 py-3">
                                                        <button className="btn btn-outline-secondary btn-sm me-2" onClick={() => editar(st)}>
                                                            <i className="bi bi-pencil"></i>
                                                        </button>
                                                        <button className="btn btn-outline-danger btn-sm" onClick={() => eliminarStaff(st.uuid)}>
                                                            <i className="bi bi-trash"></i>
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    );
}